import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useClientHeight } from '@/hooks/useClientHeight';
import { call } from '@/services/call';
import { Result } from '@/ui';
import { StyledCompatibilityList, StyledCompatibilityWarning } from './styled';

type Props = {
  children?: ReactNode;
};

const CompatibilityWarning: FC<Props> = ({ children }) => {
  const height = useClientHeight();

  const { t } = useTranslation();

  if (call.isSupported) {
    return children;
  }

  return (
    <StyledCompatibilityWarning $height={height}>
      <Result
        title={t('browser_not_supported')}
        message={t('browser_support_message')}
        image="error.svg"
      >
        <StyledCompatibilityList>
          <li>
            <a href="https://www.google.com/chrome/" target="_blank" rel="noreferrer">
              <img src="/images/chrome.svg" alt="Google Chrome" />
              <span>Google Chrome</span>
            </a>
          </li>
          <li>
            <a href="https://www.apple.com/safari/" target="_blank" rel="noreferrer">
              <img src="/images/safari.svg" alt="Safari" />
              <span>Safari</span>
            </a>
          </li>
          <li>
            <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank" rel="noreferrer">
              <img src="/images/firefox.svg" alt="Mozilla Firefox" />
              <span>Mozilla Firefox</span>
            </a>
          </li>
          <li>
            <a href="https://www.microsoft.com/en-us/edge?form=MA13FJ" target="_blank" rel="noreferrer">
              <img src="/images/edge.svg" alt="Microsoft Edge" />
              <span>Microsoft Edge</span>
            </a>
          </li>
        </StyledCompatibilityList>
      </Result>
    </StyledCompatibilityWarning>
  );
};

export default CompatibilityWarning;
